module.exports = __webpack_public_path__ + "static/media/hass.74fe6c52.png";